module.exports = __webpack_public_path__ + "static/img/bg-en.9006bb56.webp";